// extracted by mini-css-extract-plugin
export var chip = "_du-0";
export var filterDropdown = "_du-5";
export var filterItem = "_du-6";
export var icon = "_du-1";
export var removeButton = "_du-3";
export var removeIcon = "_du-4";
export var separator = "_du-2";